export const NODE_CONTEXT_IMPORT = {
  titles: {
    importCard: "Import node context",
    statusCard: "Import node status",
  },
  labels: {
    selectFile: "Select a node context file (.txt / .json)",
    noFileSelected: "No file selected",
  },
  buttons: {
    chooseFile: "Choose file",
    validate: "Validate",
    upload: "Upload",
    clear: "Clear",
    downloadReport: "Download report (.csv)",
  },
  sessionStatus: {
    neutral: "No imports run in this session.",
    accessRestricted: "Import is available when you have Data Management access.",
    importInProgress: "Import in progress…",
  },
  runChips: {
    valid: "Valid",
    complete: "Complete",
    failed: "Failed",
    refused: "Refused",
  },
  validationResults: {
    showCodesInFileSection: false,
    codesTitle: "Codes in this file",
    details: "Details",
    metrics: {
      nodes: "Nodes",
      toCreate: "To create",
      toUpdate: "To update",
      created: "Created",
      updated: "Updated",
      failed: "Failed",
    },
  },
  clientValidation: {
    wrongExtension:
      "Validation failed · only .txt or .json files are accepted · upload disabled.",
    fileTooLarge:
      "Validation failed · file exceeds 15 MB limit · upload disabled.",
    invalidJson: "Validation failed · invalid JSON · upload disabled.",
    jsonWrongShape:
      'Validation failed · JSON must be a node array or an object with a "nodes" array · upload disabled.',
  },
  serverMessages: {
    validationFailedPrefix: "Validation failed · ",
    importFailedPrefix: "Import failed · ",
    requestFailed: "Request failed.",
  },
  toast: {
    successTitle: "Success",
    errorTitle: "Error",
    defaultFailureDescription: "Something went wrong.",
    validationCompleted: "Validation completed.",
    validationDidNotPass: "Validation did not pass.",
    importCompleted: "Node context import completed.",
    importIncomplete: "Import did not complete successfully.",
  },
  statusLines: {
    totalNodes: "Total nodes:",
    createdNodes: "Created nodes:",
    updatedNodes: "Updated nodes:",
    failedNodes: "Failed nodes:",
    resolvedSources: "Resolved sources:",
    sourceNodeCounts: "Source node counts:",
    contextOnlyNodes: "Context-only nodes:",
    importStatus: "Import status:",
    validationSuccessful: "VALIDATION SUCCESSFUL",
    validationFailed: "VALIDATION FAILED",
    importSuccessful: "IMPORT SUCCESSFUL",
    importFailed: "IMPORT FAILED",
  },
  internal: {
    readFileError: "Could not read file.",
  },
};
